// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBJT28cUyuIufqPAGaMXy7j61rT8wUbpQA",
  authDomain: "ev-dderma.firebaseapp.com",
  projectId: "ev-dderma",
  storageBucket: "ev-dderma.appspot.com",
  messagingSenderId: "519604574968",
  appId: "1:519604574968:web:499d41ebc2fa30a733790d",
  measurementId: "G-YTFBJLELXF"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getFirestore(app);
export const storage = getStorage(app);


